import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative group border-2 border-primary rounded-md bg-card shadow-md flex flex-col min-w-[220px] font-mono text-sm overflow-hidden" }
const _hoisted_2 = { class: "bg-primary p-2 font-bold text-center text-primary-foreground border-b-2 border-primary" }
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = { class: "p-2 min-h-[40px] flex flex-col gap-1 bg-card" }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "absolute -top-3 -right-3 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity z-20" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex items-center gap-1 w-full justify-between" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "text-sm font-bold p-2 bg-muted-foreground/10 text-muted-foreground flex items-center justify-between border-b shrink-0" }

import { ref, watch } from 'vue'
import { 
  VueFlow, 
  useVueFlow, 
  Handle, 
  Position, 
  BaseEdge, 
  EdgeLabelRenderer, 
  getBezierPath
} from '@vue-flow/core'
import { Background } from '@vue-flow/background'
import { Controls } from '@vue-flow/controls'
import '@vue-flow/core/dist/style.css'
import '@vue-flow/core/dist/theme-default.css'
import '@vue-flow/controls/dist/style.css'
import { Button } from '@/components/ui/button'
import { Database, Plus, Trash2, RefreshCw, KeyRound } from 'lucide-vue-next'
import BaseVisualEditor from './BaseVisualEditor.vue'
import MermaidCodeEditor from './MermaidCodeEditor.vue'
import MermaidLivePreview from './MermaidLivePreview.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'EntityRelationshipEditorDialog',
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const nodes = ref<any[]>([])
const edges = ref<any[]>([])
const showCode = ref(false)
const copied = ref(false)
const editableCode = ref('')
const isParsing = ref(false)

const LEFT_CARDINALITIES = [
  { value: '||', label: 'Exactamente Uno (||)' },
  { value: '|o', label: 'Cero o Uno (|o)' },
  { value: '}|', label: 'Uno o Muchos (}|)' },
  { value: '}o', label: 'Cero o Muchos (}o)' },
]

const RIGHT_CARDINALITIES = [
  { value: '||', label: 'Exactamente Uno (||)' },
  { value: 'o|', label: 'Cero o Uno (o|)' },
  { value: '|{', label: 'Uno o Muchos (|{)' },
  { value: 'o{', label: 'Cero o Muchos (o{)' },
]

const LINE_TYPES = [
  { value: '--', label: 'Línea Sólida (--)' },
  { value: '..', label: 'Línea Punteada (..)' },
]

const initNodes = () => {
  nodes.value = [
    { 
      id: 'e_CUSTOMER', type: 'entityNode', position: { x: 100, y: 100 }, 
      data: { name: 'CUSTOMER', attributes: [{ type: 'int', name: 'id', key: 'PK' }, { type: 'string', name: 'name', key: '' }] } 
    },
    { 
      id: 'e_ORDER', type: 'entityNode', position: { x: 450, y: 100 }, 
      data: { name: 'ORDER', attributes: [{ type: 'int', name: 'id', key: 'PK' }, { type: 'int', name: 'customerId', key: 'FK' }] } 
    }
  ]
  edges.value = [
    {
      id: 'e_CUSTOMER_ORDER', source: 'e_CUSTOMER', target: 'e_ORDER', type: 'custom',
      data: { leftCard: '||', lineType: '--', rightCard: 'o{', label: 'places' }
    }
  ]
}

watch(() => props.open, (val) => {
  if (!val) {
    nodes.value = []
    edges.value = []
    editableCode.value = ''
    return
  }

  if (val) {
    const editingCode = localStorage.getItem('editingDiagramCode');
    if (editingCode) {
      setTimeout(() => {
        editableCode.value = editingCode;
        localStorage.removeItem('editingDiagramCode');
        syncToVisual();
      }, 300);
      return;
    }
  }

  if (val && nodes.value.length === 0) initNodes()
}, { immediate: true })

const { onConnect } = useVueFlow()

const handleConnect = (params: any) => {
  edges.value.push({
    id: `e-${params.source}-${params.target}-${Date.now()}`,
    source: params.source,
    target: params.target,
    type: 'custom',
    data: { 
      leftCard: '||',
      lineType: '--',
      rightCard: 'o{',
      label: 'relates'
    }
  })
}

const addEntityNode = () => {
  const id = `e_Entity_${Date.now()}`
  nodes.value.push({
    id,
    type: 'entityNode',
    position: { x: Math.random() * 200 + 100, y: Math.random() * 200 + 100 },
    data: { name: `Entity_${Math.floor(Math.random()*1000)}`, attributes: [] }
  })
}

const deleteNode = (id: string) => {
  nodes.value = nodes.value.filter(n => n.id !== id)
  edges.value = edges.value.filter(e => e.source !== id && e.target !== id)
}

const deleteEdge = (id: string) => {
  edges.value = edges.value.filter(e => e.id !== id)
}

const generateCodeString = () => {
  let mermaid = '\n```mermaid\n'
  
  const positions: Record<string, any> = {}
  nodes.value.forEach(node => {
    positions[node.data.name] = { x: Math.round(node.position.x), y: Math.round(node.position.y) }
  })
  mermaid += `%% {"positions": ${JSON.stringify(positions)}}\n`
  
  mermaid += `erDiagram\n`
  
  // Relaciones
  edges.value.forEach(edge => {
    const sNode = nodes.value.find(n => n.id === edge.source)
    const tNode = nodes.value.find(n => n.id === edge.target)
    if (sNode && tNode) {
      const { leftCard, lineType, rightCard, label } = edge.data
      mermaid += `    ${sNode.data.name} ${leftCard}${lineType}${rightCard} ${tNode.data.name} : "${label}"\n`
    }
  })

  // Entidades
  nodes.value.forEach(node => {
    mermaid += `    ${node.data.name} {\n`
    node.data.attributes.forEach((attr: any) => {
      if (attr.name.trim()) {
        const type = attr.type.trim() || 'string'
        const key = attr.key ? ` ${attr.key}` : ''
        mermaid += `        ${type} ${attr.name.trim()}${key}\n`
      }
    })
    mermaid += `    }\n`
  })

  mermaid += '```\n'
  return mermaid
}

watch([nodes, edges], () => {
  if (isParsing.value) return
  editableCode.value = generateCodeString()
}, { deep: true, immediate: true })

const syncToVisual = () => {
  isParsing.value = true
  try {
    const lines = editableCode.value.split('\n')
    const parsedNodes = new Map()
    const parsedEdges: any[] = []
    
    let currentEntity: string | null = null
    let savedPositions: Record<string, any> | null = null

    lines.forEach(line => {
      line = line.trim()
      
      // Parsear JSON oculto de posiciones
      if (line.startsWith('%% {"positions":')) {
        try {
          savedPositions = JSON.parse(line.replace(/^%% /, '')).positions
        } catch (e) {
          console.error('Error parseando metadata de posiciones', e)
        }
        return
      }

      if (!line || line.startsWith('```') || line.startsWith('erDiagram') || line.startsWith('%%')) return

      // Entities with attributes block: ENTITY {
      if (line.endsWith('{')) {
        currentEntity = line.replace('{', '').trim()
        if (!parsedNodes.has(currentEntity)) {
          parsedNodes.set(currentEntity, { name: currentEntity, attributes: [] })
        }
        return
      }

      if (line === '}') {
        currentEntity = null
        return
      }

      if (currentEntity) {
        // Parse attributes inside block
        const parts = line.split(/\s+/)
        if (parts.length >= 2) {
          const type = parts[0]
          const name = parts[1]
          let key = parts.length > 2 ? parts[2] : ''
          // Ensure key is one of PK, FK, UK if valid
          if (!['PK', 'FK', 'UK'].includes(key.toUpperCase())) {
            key = ''
          }
          parsedNodes.get(currentEntity).attributes.push({ type, name, key })
        }
        return
      }

      // Parse relations: ENTITY1 ||--o{ ENTITY2 : "label"
      const relMatch = line.match(/^([a-zA-Z0-9_]+)\s+(\|\||\|o\}\||\}o|\|o|o\||o\{|\|\{)(--|\.\.)(\|\||\|o|o\||\}o|o\{|\|\{|\}\|)\s+([a-zA-Z0-9_]+)\s*:\s*"?(.*?)"?$/)
      
      // Fallback simple split if regex misses something due to complex combinations
      if (relMatch) {
        const [, sName, leftCard, lineType, rightCard, tName, label] = relMatch
        if (!parsedNodes.has(sName)) parsedNodes.set(sName, { name: sName, attributes: [] })
        if (!parsedNodes.has(tName)) parsedNodes.set(tName, { name: tName, attributes: [] })
        
        parsedEdges.push({
          sourceName: sName,
          targetName: tName,
          leftCard,
          lineType,
          rightCard,
          label
        })
      } else {
        // Intento manual más flexible
        const parts = line.split(':')
        if (parts.length === 2) {
          const leftSide = parts[0].trim()
          const label = parts[1].replace(/"/g, '').trim()
          
          const matchParts = leftSide.match(/^([a-zA-Z0-9_]+)\s+(.+?)\s+([a-zA-Z0-9_]+)$/)
          if (matchParts) {
            const sName = matchParts[1]
            const relationString = matchParts[2]
            const tName = matchParts[3]
            
            const lineType = relationString.includes('..') ? '..' : '--'
            const cards = relationString.split(lineType)
            if (cards.length === 2) {
              if (!parsedNodes.has(sName)) parsedNodes.set(sName, { name: sName, attributes: [] })
              if (!parsedNodes.has(tName)) parsedNodes.set(tName, { name: tName, attributes: [] })
              
              parsedEdges.push({
                sourceName: sName,
                targetName: tName,
                leftCard: cards[0],
                lineType,
                rightCard: cards[1],
                label
              })
            }
          }
        }
      }
    })

    const newNodes: any[] = []
    let x = 100, y = 100
    
    parsedNodes.forEach((data, name) => {
      const existing = nodes.value.find(n => n.data.name === name)
      
      let pos = { x, y }
      if (savedPositions && savedPositions[name]) {
        pos = savedPositions[name]
      } else if (existing) {
        pos = existing.position
      } else {
        y += 50
      }

      newNodes.push({
        id: existing?.id || `e_${name}_${Date.now()}_${Math.random()}`,
        type: 'entityNode',
        position: pos,
        data: { ...data }
      })
      
      if (!savedPositions || !savedPositions[name]) {
        x += 20
      }
    })

    const newEdges: any[] = []
    parsedEdges.forEach(pe => {
      const sNode = newNodes.find(n => n.data.name === pe.sourceName)
      const tNode = newNodes.find(n => n.data.name === pe.targetName)
      if (sNode && tNode) {
        newEdges.push({
          id: `e-${sNode.id}-${tNode.id}-${Date.now()}-${Math.random()}`,
          source: sNode.id,
          target: tNode.id,
          type: 'custom',
          data: {
            leftCard: pe.leftCard,
            lineType: pe.lineType,
            rightCard: pe.rightCard,
            label: pe.label
          }
        })
      }
    })

    nodes.value = newNodes
    edges.value = newEdges

  } catch (error) {
    console.error("Error parsing ER code:", error)
  } finally {
    setTimeout(() => { isParsing.value = false }, 100)
  }
}

const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(editableCode.value)
    copied.value = true
    setTimeout(() => copied.value = false, 2000)
  } catch (e) {
    console.error('Failed to copy', e)
  }
}

const generateMermaid = () => {
  emit('save', editableCode.value)
  emit('update:open', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseVisualEditor, {
    open: __props.open,
    "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:open', $event))),
    title: "Diagrama Entidad-Relación (ER)",
    description: "Modela bases de datos. Crea entidades, añade atributos con sus tipos y llaves (PK/FK), y conéctalas con sus cardinalidades correctas.",
    showCode: showCode.value,
    "onUpdate:showCode": _cache[4] || (_cache[4] = ($event: any) => (showCode.value = $event)),
    copied: copied.value,
    onCopy: copyToClipboard,
    onSave: generateMermaid
  }, {
    icon: _withCtx(() => [
      _createVNode(_unref(Database), { class: "w-5 h-5 text-primary" })
    ]),
    toolbar: _withCtx(() => [
      _createVNode(_unref(Button), {
        size: "sm",
        onClick: addEntityNode
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Plus), { class: "w-4 h-4 mr-2" }),
          _cache[5] || (_cache[5] = _createTextVNode(" Añadir Entidad", -1))
        ]),
        _: 1
      })
    ]),
    canvas: _withCtx(() => [
      _createVNode(_unref(VueFlow), {
        nodes: nodes.value,
        "onUpdate:nodes": _cache[0] || (_cache[0] = ($event: any) => ((nodes).value = $event)),
        edges: edges.value,
        "onUpdate:edges": _cache[1] || (_cache[1] = ($event: any) => ((edges).value = $event)),
        onConnect: handleConnect,
        "default-zoom": 1
      }, {
        "node-entityNode": _withCtx((nodeProps) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((nodeProps.data.name) = $event),
                class: "bg-transparent text-center w-full focus:outline-none",
                placeholder: "ENTITY_NAME"
              }, null, 8, _hoisted_3), [
                [_vModelText, nodeProps.data.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nodeProps.data.attributes, (attr, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "flex items-center gap-1 group/item"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((nodeProps.data.attributes[i].type) = $event),
                    class: "bg-transparent text-xs w-[60px] text-muted-foreground focus:outline-none focus:bg-muted/50 rounded px-1",
                    placeholder: "int"
                  }, null, 8, _hoisted_5), [
                    [_vModelText, nodeProps.data.attributes[i].type]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((nodeProps.data.attributes[i].name) = $event),
                    class: "bg-transparent text-xs flex-1 font-semibold focus:outline-none focus:bg-muted/50 rounded px-1",
                    placeholder: "id"
                  }, null, 8, _hoisted_6), [
                    [_vModelText, nodeProps.data.attributes[i].name]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": ($event: any) => ((nodeProps.data.attributes[i].key) = $event),
                    class: "text-[10px] bg-transparent outline-none p-0 appearance-none font-bold text-yellow-600 dark:text-yellow-400 cursor-pointer text-center w-6"
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("option", { value: "" }, "-", -1),
                    _createElementVNode("option", { value: "PK" }, "PK", -1),
                    _createElementVNode("option", { value: "FK" }, "FK", -1),
                    _createElementVNode("option", { value: "UK" }, "UK", -1)
                  ]))], 8, _hoisted_7), [
                    [_vModelSelect, nodeProps.data.attributes[i].key]
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (nodeProps.data.attributes.splice(i, 1)),
                    class: "text-destructive opacity-0 group-hover/item:opacity-100 shrink-0"
                  }, [
                    _createVNode(_unref(Trash2), { class: "w-3 h-3" })
                  ], 8, _hoisted_8)
                ]))
              }), 128)),
              _createElementVNode("button", {
                onClick: ($event: any) => (nodeProps.data.attributes.push({ type: 'string', name: 'newField', key: '' })),
                class: "text-[10px] text-muted-foreground hover:text-primary text-left mt-2 flex items-center gap-1"
              }, [
                _createVNode(_unref(Plus), { class: "w-3 h-3" }),
                _cache[7] || (_cache[7] = _createTextVNode(" Añadir atributo ", -1))
              ], 8, _hoisted_9)
            ]),
            _createVNode(_unref(Handle), {
              type: "target",
              position: _unref(Position).Top,
              id: "top"
            }, null, 8, ["position"]),
            _createVNode(_unref(Handle), {
              type: "source",
              position: _unref(Position).Bottom,
              id: "bottom"
            }, null, 8, ["position"]),
            _createVNode(_unref(Handle), {
              type: "source",
              position: _unref(Position).Right,
              id: "right"
            }, null, 8, ["position"]),
            _createVNode(_unref(Handle), {
              type: "target",
              position: _unref(Position).Left,
              id: "left"
            }, null, 8, ["position"]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                onClick: _withModifiers(($event: any) => (deleteNode(nodeProps.id)), ["stop"]),
                class: "bg-destructive text-white rounded-full w-6 h-6 flex items-center justify-center hover:scale-110 shadow-sm",
                title: "Eliminar Entidad"
              }, "×", 8, _hoisted_11)
            ])
          ])
        ]),
        "edge-custom": _withCtx((edgeProps) => [
          _createVNode(_unref(BaseEdge), {
            id: edgeProps.id,
            path: _unref(getBezierPath)(edgeProps)[0],
            class: "vue-flow__edge-path",
            style: _normalizeStyle({ 
              strokeWidth: 2, 
              stroke: 'hsl(var(--primary))', 
              strokeDasharray: edgeProps.data.lineType === '..' ? '5,5' : '0' 
            })
          }, null, 8, ["id", "path", "style"]),
          _createVNode(_unref(EdgeLabelRenderer), null, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                style: _normalizeStyle({
                position: 'absolute',
                transform: `translate(-50%, -50%) translate(${_unref(getBezierPath)(edgeProps)[1]}px,${_unref(getBezierPath)(edgeProps)[2]}px)`,
                pointerEvents: 'all',
              }),
                class: "nodrag nopan bg-card border shadow-md rounded p-1 group z-10 flex flex-col gap-1 w-[200px]"
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": ($event: any) => ((edgeProps.data.leftCard) = $event),
                    class: "text-[10px] border rounded bg-background focus:outline-none w-[60px]",
                    title: "Cardinalidad Izquierda (Origen)"
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(LEFT_CARDINALITIES, (c) => {
                      return _createElementVNode("option", {
                        key: c.value,
                        value: c.value
                      }, _toDisplayString(c.value), 9, _hoisted_14)
                    }), 64))
                  ], 8, _hoisted_13), [
                    [_vModelSelect, edgeProps.data.leftCard]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": ($event: any) => ((edgeProps.data.lineType) = $event),
                    class: "text-[10px] border rounded bg-background focus:outline-none flex-1 text-center font-bold text-muted-foreground",
                    title: "Tipo de Línea"
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(LINE_TYPES, (l) => {
                      return _createElementVNode("option", {
                        key: l.value,
                        value: l.value
                      }, _toDisplayString(l.value), 9, _hoisted_16)
                    }), 64))
                  ], 8, _hoisted_15), [
                    [_vModelSelect, edgeProps.data.lineType]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": ($event: any) => ((edgeProps.data.rightCard) = $event),
                    class: "text-[10px] border rounded bg-background focus:outline-none w-[60px]",
                    title: "Cardinalidad Derecha (Destino)"
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(RIGHT_CARDINALITIES, (c) => {
                      return _createElementVNode("option", {
                        key: c.value,
                        value: c.value
                      }, _toDisplayString(c.value), 9, _hoisted_18)
                    }), 64))
                  ], 8, _hoisted_17), [
                    [_vModelSelect, edgeProps.data.rightCard]
                  ])
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((edgeProps.data.label) = $event),
                  class: "w-full bg-background text-center border rounded p-1 text-[10px] text-foreground focus:outline-none font-mono",
                  placeholder: "Verbo de relación..."
                }, null, 8, _hoisted_19), [
                  [_vModelText, edgeProps.data.label]
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (deleteEdge(edgeProps.id)),
                  class: "absolute -top-2 -right-2 bg-destructive text-white rounded-full w-4 h-4 flex items-center justify-center text-[10px] opacity-0 group-hover:opacity-100 transition-opacity shadow-sm",
                  title: "Eliminar Conexión"
                }, "×", 8, _hoisted_20)
              ], 4)
            ]),
            _: 2
          }, 1024)
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Background)),
          _createVNode(_unref(Controls))
        ]),
        _: 1
      }, 8, ["nodes", "edges"])
    ]),
    "code-panel": _withCtx(() => [
      _createElementVNode("div", _hoisted_21, [
        _cache[9] || (_cache[9] = _createTextVNode(" Mermaid (Sincronizado) ", -1)),
        _createVNode(_unref(Button), {
          size: "sm",
          variant: "default",
          class: "h-7 text-xs",
          onClick: syncToVisual
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(RefreshCw), { class: "w-3 h-3 mr-2" }),
            _cache[8] || (_cache[8] = _createTextVNode(" Sincronizar a Visual ", -1))
          ]),
          _: 1
        })
      ]),
      _createVNode(MermaidCodeEditor, {
        modelValue: editableCode.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editableCode).value = $event)),
        class: "flex-1 min-h-0"
      }, null, 8, ["modelValue"])
    ]),
    "live-preview": _withCtx(() => [
      _createVNode(MermaidLivePreview, { code: editableCode.value }, null, 8, ["code"])
    ]),
    _: 1
  }, 8, ["open", "showCode", "copied"]))
}
}

})